import React from "react"
import { Typography, withStyles } from "@material-ui/core"

const style = (theme) => ({
    padding: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
})

const pMd = ({classes, insidePaper, children}) => {
    return <Typography paragraph children={children} className={insidePaper ? classes.padding : ""} />
}

export const PMd = withStyles(style)(pMd);
